import { AccountIdentifier, IcpLedgerCanister, SubAccount } from '@icp-sdk/canisters/ledger/icp'
import { IcrcLedgerCanister } from '@icp-sdk/canisters/ledger/icrc'
import { HttpAgent } from '@icp-sdk/core/agent'
import { Principal } from '@icp-sdk/core/principal'
import getTokenActor from './getTokenActor'

const getTokenBalance = async (
  canisterId: string,
  standard: string,
  agent: HttpAgent,
  principal: string,
  subaccount?: number[] | Uint8Array
) => {
  switch (standard) {
    case 'ICP':
      const icpLedger = IcpLedgerCanister.create({
        agent,
        canisterId: Principal.fromText(canisterId),
      })

      // https://github.com/dfinity/ic-js/issues/934
      const subAccount = subaccount && SubAccount.fromBytes(Uint8Array.from(subaccount))
      if (subAccount instanceof Error) {
        throw 'Failed to instantiate subaccount'
      }

      const accountIdentifier = AccountIdentifier.fromPrincipal({
        principal: Principal.fromText(principal),
        subAccount,
      })
      return icpLedger.accountBalance({
        accountIdentifier,
      })
    case 'ICRC1':
    case 'ICRC2':
    case 'ICRC3':
      const icrcLedger = IcrcLedgerCanister.create({
        agent,
        canisterId: Principal.fromText(canisterId),
      })

      return icrcLedger.balance({
        owner: Principal.fromText(principal),
        // Candid blobs are Uint8Array in @icp-sdk/canisters; callers may pass either.
        subaccount: subaccount ? Uint8Array.from(subaccount) : undefined,
      })
    default:
      const actor = getTokenActor(canisterId, standard, agent)

      if (actor.dip20) {
        return actor.dip20.balanceOf(Principal.fromText(principal))
      }

      if (actor.drc20) {
        return actor.drc20.drc20_balanceOf(principal)
      }

      if (actor.xtc) {
        return actor.xtc.balanceOf(Principal.fromText(principal))
      }

      return Promise.reject('Unsupported token')
  }
}

export default getTokenBalance
